import React from "react";
import './App.css';
import { CheckCircle, Shield, Zap, Wrench, Phone, MapPin, ArrowRight } from "lucide-react";

// Conversão: Tailwind -> CSS puro
// Esta versão mantém a estrutura React, mas substitui utilitários Tailwind por CSS definido abaixo.

export default function PoliSteelLanding() {
  const COLORS = {
    black: "#141414",
    gold: "#e6b967",
    dark: "#2a2a2a",
    beige: "#f5f1e8",
    white: "#fafafa",
  };

  const wa =
    "https://wa.me/5519971113901?text=Ol%C3%A1%2C%20gostaria%20de%20or%C3%A7amento%20para%20servi%C3%A7o%20de%20solda%20(rodas%20de%20alum%C3%ADnio%2C%20bloco%20de%20motor%2C%20port%C3%B5es%2C%20etc.).%20Sou%20de%20Campinas%20e%20regi%C3%A3o.";

  return (
    <div className="ps-root" style={{ fontFamily: "Montserrat, ui-sans-serif, system-ui" }}>
      {/* Google Font - mantém */}
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700;800&display=swap" rel="stylesheet" />

      {/* HEADER */}
      <header className="ps-header">
        <div className="ps-header-inner">
          <div className="ps-logo">
            <img src='/logo.png' style={{width:'34px', height:'34px', objectFit: 'cover'}}/>
            <span style={{ fontWeight: 800, letterSpacing: 0.6 }}>POLI STEEL</span>
          </div>
          <a 
            href={wa} 
            className="ps-nav-button" 
            target="_blank"
            onClick={() => {
              window.dataLayer.push({
                event: 'whatsapp_click',
                position: 'header',
                path: window.location.pathname
              });
            }}
          >
            <Phone size={16} /> Orçamento no WhatsApp
          </a>
        </div>
      </header>

      {/* HERO */}
      <section className="ps-hero">
        <div className="ps-hero-inner">
          <div>
            <h1 className="ps-hero-title">
              Rodas trincadas? Peças quebradas?
              <br />
              <span className="ps-hero-gold">Solda profissional em alumínio e inox</span> em Campinas e região.
            </h1>
            <p className="ps-hero-desc">
              Recuperamos, reforçamos e damos nova vida às suas peças com acabamento impecável. Atendimento em Campinas, Sumaré, Hortolândia,
              Valinhos e cidades vizinhas.
            </p>

            <div className="ps-hero-ctas">
              <a 
                href={wa} 
                className="ps-cta" 
                target="_blank"
                onClick={() => {
                  window.dataLayer.push({
                    event: 'whatsapp_click',
                    position: 'secao-banner',
                    path: window.location.pathname
                  });
                }}
              >
                Pedir orçamento no WhatsApp <ArrowRight size={18} />
              </a>
              <div className="ps-badge">
                <Shield size={16} /> Garantia de serviço
              </div>
            </div>

            <div className="ps-bullets">
              {[
                "Rodas de alumínio (carros e motos)",
                "Blocos de motor",
                "Portões, grades e corrimões"
              ].map((item) => (
                <div
                  key={item}
                  style={{ display: "flex", gap: 8, alignItems: "center" }}
                >
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <CheckCircle size={18} color={COLORS.gold} />
                  </div>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="ps-hero-media">
            <div className="placeholder">
              <div style={{ textAlign: "center" }}>
                {/* <div style={{ fontSize: 54 }}>⚡️</div> */}
                <img src="/principal.jpg" id="imagemprincipal" style={{width:'100%', objectFit:'cover'}}/>
              </div>
            </div>

            <div className="ps-hero-geo">
              <MapPin size={16} color={COLORS.gold} /> Campinas • Região metropolitana
            </div>
          </div>
        </div>
      </section>

      {/* BENEFÍCIOS */}
      <section className="ps-benefits">
        <div className="ps-benefits-grid ps-container">
          {[
            { icon: <Wrench />, title: "Especialistas em alumínio e inox", desc: "Solda precisa e acabamento profissional." },
            { icon: <Zap />, title: "Atendimento rápido", desc: "Serviços concluídos em poucas horas." },
            { icon: <Shield />, title: "Qualidade garantida", desc: "Reforço e durabilidade de verdade." },
            { icon: <Phone />, title: "Orçamento no WhatsApp", desc: "Envie a foto da peça e receba o valor." },
          ].map((b) => (
            <div key={b.title} className="ps-benefit">
              <div className="icon">{b.icon}</div>
              <h3 style={{ margin: 0 }}>{b.title}</h3>
              <p style={{ marginTop: 6 }}>{b.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* SERVICES */}
      <section className="ps-services">
        <div className="ps-container">
          <h2 className="title">
            <span style={{ color: COLORS.gold }}>Serviços</span> que realizamos
          </h2>

          <div className="ps-services-grid">
            {[
              {
                title: "Rodas de alumínio (carros e motos)",
                desc: "Reparo de trincas, amassados e reforço estrutural. Economia vs. troca da peça.",
              },
              { title: "Blocos de motor", desc: "Solda técnica e precisa para trincas e quebras." },
              { title: "Tanques de diesel", desc: "Reparo de vazamentos e reforço em alumínio e inox." },
              { title: "Portões, grades e corrimões", desc: "Solda e manutenção residencial/comercial." },
              { title: "Escapamentos e radiadores", desc: "Recuperação de peças automotivas em metal." },
              { title: "Moldes e peças industriais", desc: "Solda em alumínio/inox para indústria e agricultura." },
            ].map((s) => (
              <div key={s.title} className="ps-service-card">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>

          <div className="ps-services-cta">
            <a 
              href={wa} 
              target="_blank" 
              className="ps-cta"
              onClick={() => {
                window.dataLayer.push({
                  event: 'whatsapp_click',
                  position: 'secao-servico',
                  path: window.location.pathname
                });
              }}
            >Pedir orçamento no WhatsApp <ArrowRight size={18} /></a>
          </div>
        </div>
      </section>

      {/* GALLERY */}
      <section className="ps-gallery">
        <div className="ps-container">
          <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 8 }}>Antes <span style={{ color: COLORS.gold }}>&</span> Depois</h2>
          <p style={{ color: COLORS.beige, marginBottom: 12 }}>Substitua os blocos abaixo por fotos reais dos serviços do Jessé (ideal: rodas de alumínio).</p>

          <div className="ps-gallery-grid">
            {[
              '/antes e depois  3.jpg','/antes e depois 2.jpg','/antes e depois principal.jpg'
            ].map((i) => (
              <div key={i} className="ps-gallery-item">
                <img src={i} class="imagemsecundaria" style={{width: '100%', objectFit: 'cover'}} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="ps-cta-final">
        <div className="inner">
          <h2>Envie sua foto e receba o valor <span style={{ color: COLORS.gold }}>agora</span></h2>
          <p>Atendimento rápido no WhatsApp. Campinas, Sumaré, Hortolândia, Valinhos e região.</p>
          <a 
            href={wa} 
            target="_blank" 
            className="btn"
            onClick={() => {
              window.dataLayer.push({
                event: 'whatsapp_click',
                position: 'secao-cta',
                path: window.location.pathname
              });
            }}
          >Pedir orçamento no WhatsApp <ArrowRight size={18} /></a>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="inner">
          <div style={{ display: "flex", gap: 8, alignItems: "center"}}>
            <img src='/logo.png' style={{width:'28px', height:'28px', objectFit: 'cover'}}/>
            <strong>Poli Steel</strong>
          </div>

          <div style={{ color: COLORS.beige }}>Campinas • Sumaré • Hortolândia • Valinhos • Região Metropolitana</div>

          <a 
            href={wa} 
            target="_blank"
            onClick={() => {
              window.dataLayer.push({
                event: 'whatsapp_click',
                position: 'footer',
                path: window.location.pathname
              });
            }}
          ><Phone size={14} /> WhatsApp: (19) 97111-3901</a>
        </div>
      </footer>

      {/* FAB WhatsApp */}
      <a 
        href={wa} 
        target="_blank" 
        className="ps-fab" 
        aria-label="Abrir WhatsApp"
        onClick={() => {
          window.dataLayer.push({
            event: 'whatsapp_click',
            position: 'fab',
            path: window.location.pathname
          });
        }}
      >
        <svg fill="#000000" width="34px" height="34px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <title>whatsapp</title>
          <path d="M26.576 5.363c-2.69-2.69-6.406-4.354-10.511-4.354-8.209 0-14.865 6.655-14.865 14.865 0 2.732 0.737 5.291 2.022 7.491l-0.038-0.070-2.109 7.702 7.879-2.067c2.051 1.139 4.498 1.809 7.102 1.809h0.006c8.209-0.003 14.862-6.659 14.862-14.868 0-4.103-1.662-7.817-4.349-10.507l0 0zM16.062 28.228h-0.005c-0 0-0.001 0-0.001 0-2.319 0-4.489-0.64-6.342-1.753l0.056 0.031-0.451-0.267-4.675 1.227 1.247-4.559-0.294-0.467c-1.185-1.862-1.889-4.131-1.889-6.565 0-6.822 5.531-12.353 12.353-12.353s12.353 5.531 12.353 12.353c0 6.822-5.53 12.353-12.353 12.353h-0zM22.838 18.977c-0.371-0.186-2.197-1.083-2.537-1.208-0.341-0.124-0.589-0.185-0.837 0.187-0.246 0.371-0.958 1.207-1.175 1.455-0.216 0.249-0.434 0.279-0.805 0.094-1.15-0.466-2.138-1.087-2.997-1.852l0.010 0.009c-0.799-0.74-1.484-1.587-2.037-2.521l-0.028-0.052c-0.216-0.371-0.023-0.572 0.162-0.757 0.167-0.166 0.372-0.434 0.557-0.65 0.146-0.179 0.271-0.384 0.366-0.604l0.006-0.017c0.043-0.087 0.068-0.188 0.068-0.296 0-0.131-0.037-0.253-0.101-0.357l0.002 0.003c-0.094-0.186-0.836-2.014-1.145-2.758-0.302-0.724-0.609-0.625-0.836-0.637-0.216-0.010-0.464-0.012-0.712-0.012-0.395 0.010-0.746 0.188-0.988 0.463l-0.001 0.002c-0.802 0.761-1.3 1.834-1.3 3.023 0 0.026 0 0.053 0.001 0.079l-0-0.004c0.131 1.467 0.681 2.784 1.527 3.857l-0.012-0.015c1.604 2.379 3.742 4.282 6.251 5.564l0.094 0.043c0.548 0.248 1.25 0.513 1.968 0.74l0.149 0.041c0.442 0.14 0.951 0.221 1.479 0.221 0.303 0 0.601-0.027 0.889-0.078l-0.031 0.004c1.069-0.223 1.956-0.868 2.497-1.749l0.009-0.017c0.165-0.366 0.261-0.793 0.261-1.242 0-0.185-0.016-0.366-0.047-0.542l0.003 0.019c-0.092-0.155-0.34-0.247-0.712-0.434z"></path>
        </svg>
      </a>
    </div>
  );
}
